<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.grupo"
        ref="RkmDataTable"
        sort-by="descricao"
    >

        <template v-slot:cell(actions)="{ item }">
            <template v-if="!$scopedSlots.actions">
                <rkm-button
                    @click="handleEdit(item.id)"
                    color="primary"
                    small
                    title="Editar"
                    autorize="edit-transporte-paciente-grupo"
                >
                    <rkm-icon icon="pen"/>
                </rkm-button>

                <rkm-button
                    v-if="!item.bloqueado"
                    @click="handleBlock(item.id, false)"
                    color="dark"
                    small
                    title="Inativar"
                    autorize="update-transporte-paciente-grupo"
                >
                    <rkm-icon icon="ban"/>
                </rkm-button>

                <rkm-button
                    v-else
                    @click="handleBlock(item.id, true)"
                    color="success"
                    small
                    title="Ativar"
                    autorize="update-transporte-paciente-grupo"
                >
                    <rkm-icon icon="check-circle"/>
                </rkm-button>

                <rkm-button
                    @click="handleDestroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                    autorize="destroy-transporte-paciente-grupo"
                >
                    <rkm-icon icon="trash"/>
                </rkm-button>

                <slot
                    name="actions"
                    :destino="item"
                />
            </template>
        </template>
    </rkm-data-table>
</template>

<script>

// Mixins.
import { error, repository, stringCase} from '@/mixins';

export default {
    computed: {
        fields() {
            return [
                {
                    key: 'descricao',
                    label: 'Descrição',
                    name: 'transportePacienteGrupo.descricao',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'status',
                    label: 'Status',
                    name: 'transportePacienteGrupo.bloqueado',
                    searchable: true,
                    sortable: true
                },
                {
                    class: 'col-min text-center',
                    key: 'actions',
                    label: 'Ações',
                },
            ];
        }
    },
    created() {
        this.repositories = {
            grupo: this.getConectaSusRepository('transportePaciente.grupo')
        }
    },
    methods: {
        handleEdit(id) {
            this.$router.push({ name: 'transporte-paciente-grupo-edit', params: { id: id } })
        },
        handleBlock(id, ativar) {

            const bloqueio = () => this.repositories.grupo.bloquear(id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showConfirmation(
                `Deseja realmente ${ativar ? 'ativar' : 'inativar'} o grupo?`,
                bloqueio,
                null,
                this.handleError
            )
        },
        handleDestroy(item) {

            if (!item.deleteGrupo) {

                this.showAlert(
                    'Não é possível excluir o grupo devido à existência de registros vinculados a ele.', 'Atenção',
                )

            } else {

                const exclusao = () => this.repositories.grupo.destroy(item.id)
                .then(() => this.$refs.RkmDataTable.refresh())

                this.showDeleteConfirmation(
                    'Deseja realmente excluir o grupo?',
                    exclusao,
                    this.handleError
                )
            }
        },
    },
    mixins: [ error, repository, stringCase ],
};

</script>